export default __webpack_public_path__ + "static/media/playstoreIcon.89512fa6.svg";